import React, { useState } from 'react';
import { useStore } from 'effector-react';
import { HSIconType } from '@types';
import Tabbar from '@components/Tabbar';
import { $editingHotspot } from '@stores/editingHotspotStores';
import WidgetItem from '@components/PlayerWidgets/WidgetItem';
import DetailTab from './DetailTab';
import ChromakeyTab from './ChromakeyTab';

function ImageWidget() {
  const { hotspot } = useStore($editingHotspot)!;
  const [tab, setTab] = useState(0);

  const title =
    hotspot.icon.type === HSIconType.video ? '视频高级设置' : '图片高级设置';

  return (
    <WidgetItem title={title}>
      <Tabbar
        className="mb-10"
        tabs={['细节', '抠像']}
        activeIndex={tab}
        onChange={setTab}
      />
      {tab === 0 && <DetailTab />}
      {tab === 1 && <ChromakeyTab />}
    </WidgetItem>
  );
}

export default ImageWidget;
